import React from 'react'
import styled from 'styled-components'

import { media, mediaMax } from 'styles/media'

import Signup from './Signup'
import { Subheading } from './styles'

const HeaderWrapper = styled.div`
  background-color: ${({ theme }) => theme?.['-ds-core-50']?.value};
  width: 100%;

  ${mediaMax.md`
    padding: 0 16px;
  `}
`

const HeaderInner = styled.div`
  max-width: 990px;
  margin: 0 auto;
  padding: 80px 0;

  text-align: center;
  color: ${({ theme }) => theme?.['-ds-core-300']?.value};

  ${media.md`
    padding: 120px 0;
  `}
`

const PageTitle = styled.h1`
  line-height: 1.1;
  font-weight: 400;
  margin-bottom: 16px;
  text-align: center;

  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xl']?.['font-size']?.value};

  ${media.md`
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xxxl']?.['font-size']?.value};
  `}
`

interface HeaderProps {
  cityName: string
  marketName: string
  signUpUrl: string
  signUpToken: string
}

const Header = ({
  cityName,
  marketName,
  signUpUrl,
  signUpToken,
}: HeaderProps) => {
  return (
    <HeaderWrapper>
      <HeaderInner>
        <PageTitle>{cityName}, it’s almost time for a vacation.</PageTitle>

        <Subheading>
          Whether you’re chasing adventure or time out in nature, we’re here to
          help you plan and book your next short nature escape. For news about
          our 2022 launch in {marketName}, early bookings and adventure advice,
          sign up and stay in the know!
        </Subheading>

        <Signup action={signUpUrl} token={signUpToken} />
      </HeaderInner>
    </HeaderWrapper>
  )
}

export default Header
